<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="mergeMaterialDetails"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="委外单号" prop="billNo">
            <el-input v-model="filter.billNo" clearable/>
          </el-form-item>
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="filter.materialName" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <order-confirmation-record-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";

  export default {
    name: "MergeMaterialOrderDetailList",
    components: { viewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: this.$auth(762),
          delAuth: this.$auth(763),
        },
        filter: {
          isEnd: '',
          productionNo: '',
          station: '',
          componentMaterialNo: '',
          componentBarcode: '',
          createIpAddress: '',
          endIpAddress: '',
          standardCode: '',
          procedureName: '',
        },
        selection: [],
        editVisible: false,
        editData: {},
        columnsProperty: [
          {
          tooltip: true, key: "billNo", width: 160, align: "center" },
          {
          tooltip: true, key: "station", width: 160, align: "center" },
          {
          tooltip: true, key: "sn", width: 160, align: "center" },
          {
          tooltip: true, key: "createIpAddress", width: 160, align: "center" },
          {
          tooltip: true, key: "endIpAddress", width: 160, align: "center" },
          {
          tooltip: true, key: "standardCode", width: 160, align: "center" },
          {
          tooltip: true, key: "procedureName", width: 150, align: "center"},
          {
          tooltip: true, key: "note", width: 150, align: "center" },
          // { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    mounted() {
    },
    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "orderConfirmationRecords", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },
    },
  };
</script>